import { useState, useEffect } from 'react';
import Chip from 'Components/Chip';
import {
  CardActionArea,
  CardActions,
  Typography,
  CardMedia,
  CardContent,
  Card,
  Avatar,
  Divider,
  CircularProgress,
} from '@mui/material';
import { ImageOutlined, Edit, PersonOutlineOutlined } from '@mui/icons-material';
import { colors } from 'Constants/Colors';
import { s3 } from 'Services/AWS/s3';
import DraftChip from 'Components/DraftChip';
import {
  Title,
  IconContaniner,
  ChipContaniner,
  ContaninerRelative,
  EmptyImage,
  IconProgres,
  IconStyle,
  LoadingContainer,
} from './style';
import CourseStatusChip from './CourseStatusChip';

export default function MyCourseCard({
  title = '',
  description = '',
  progress = null,
  category = null,
  image = null,
  userImage = 'src/fake',
  userCreatedName = '',
  colorCategory = colors.GREEN,
  editEvent = () => {},
  clickAction = null,
  isDraft = false,
  status = {
    id: null,
    name: null,
  },
}) {
  const [isLoading, setIsLoading] = useState(image !== null);
  const [fetchedImage, setFetchedImage] = useState(null);
  let imageContent;

  useEffect(() => {
    let isMounted = true;
    if (image) {
      s3.getSignedUrl(image)
        .then(({ signedUrl }) => {
          if (signedUrl) {
            setFetchedImage(signedUrl);
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    }

    return () => {
      isMounted = false;
      setFetchedImage(null);
      setIsLoading(image !== null);
    };
  }, [image]);

  if (image === null) {
    imageContent = (
      <EmptyImage>
        <ImageOutlined fontSize="large" style={IconStyle} />
        <ChipContaniner>
          <DraftChip visible={!!isDraft} />
        </ChipContaniner>
      </EmptyImage>
    );
  }

  if (image !== null && isLoading) {
    imageContent = (
      <LoadingContainer>
        <CircularProgress color="success" />
      </LoadingContainer>
    );
  }

  if (fetchedImage !== null && !isLoading) {
    imageContent = <CardMedia component="img" height="180" image={fetchedImage} />;
  }

  return (
    <Card
      sx={{
        maxWidth: 345,
        minWidth: 345,
        width: 345,
        position: 'relative',
        overflow: 'visible',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {editEvent !== null ? (
        <IconContaniner onClick={editEvent}>
          <Edit fontSize="medium" style={{ color: 'white' }} />
        </IconContaniner>
      ) : null}
      <CardActionArea
        onClick={clickAction === null ? null : clickAction}
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          height: '100%',
        }}
      >
        <ContaninerRelative>
          {imageContent}
          <CourseStatusChip id={status.id} name={status.name} />
          {category === null ? null : (
            <ChipContaniner>
              <DraftChip visible={!!isDraft} />
              <Chip style={{ background: colorCategory, border: 'none' }}>
                {null}
                <h4 style={{ color: 'white' }}>{category}</h4>
              </Chip>
            </ChipContaniner>
          )}
        </ContaninerRelative>

        <CardContent
          sx={{
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between',
            alignItems: 'start',
            width: '100%',
          }}
        >
          <Title>{title}</Title>
          <Typography
            variant="body2"
            color="text.secondary"
            /** Permite mostrar un máximo de 3 lineas de parrafo */
            sx={{
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              WebkitLineClamp: 3,
            }}
          >
            {description}
          </Typography>
          <Chip style={{ marginTop: '1rem', border: 'none' }}>
            <Avatar alt={userCreatedName} src={userImage} />
            <h4>{userCreatedName}</h4>
          </Chip>
        </CardContent>
      </CardActionArea>
      <Divider variant="large" />
      <CardActions>
        <Chip>
          <PersonOutlineOutlined style={IconProgres} />
          <h4>{progress}</h4>
        </Chip>
      </CardActions>
    </Card>
  );
}
